// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton_skeleton__5OBFX","skeletonShimmer":"skeleton_skeletonShimmer__n0Bmi","fadeImg":"skeleton_fadeImg__aBvPj","loaded":"skeleton_loaded__qUVFy"};